import React from 'react';

import RecipesGallery from '../components/RecipeGallery';

function PrincipalRecipesPage() {
  return (
    <div>
      <RecipesGallery onlyPrincipal={true} />
    </div>
  );
}

export default PrincipalRecipesPage;